/* eslint-disable import/no-anonymous-default-export */
import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios";
import { IFile, IGetProtocolRegisterResult, IProtocolRegisterRequest } from "../shared/interfaces";

const controller = 'ProtocolRegister';

const getProtocolRegisters = (aooId: number, protocolRegisterRequest: IProtocolRegisterRequest, cancelToken?: CancelToken): Promise<IGetProtocolRegisterResult> => {
    return axiosInstance.post(`${controller}/${aooId}/GetProtocolRegisters`, protocolRegisterRequest, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


const getProtocolRegisterFile = (aooId: number, protocolRegisterId: number, cancelToken?: CancelToken): Promise<IFile> => {
    return axiosInstance.get(`${controller}/${aooId}/GetProtocolRegisterFile/${protocolRegisterId}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

export default {
    getProtocolRegisters,
    getProtocolRegisterFile
}